import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { RegistrationComponent } from "./registration/registration.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { UserComponent } from "./pages/user/user.component";
import { ContainerComponent } from "./pages/container.component";
import { UniversalCrudComponent } from "@stdoutsrl/design-kit";
import { boatTypes, bundles, customers, employees, floatingBoats, locations, rates } from "./models/universal-json";
import { mockData } from "../mockData";
import { AvailabilityComponent } from "./pages/availability/availability.component";

let routes: Routes = [
  {path:"",component:ContainerComponent,
    children:[]
  },
  {
    path: "manager",
    component: PagesComponent,
    children: [{ path: "profilo", component: UserComponent },
    { path: "tipo-barche", component: UniversalCrudComponent,data:{ ...boatTypes, mockData: mockData } ,title:'Tipo Barche'},
    { path: "gommoni", component: UniversalCrudComponent,data:{ ...floatingBoats, mockData: mockData } ,title:'Gommoni'},
    { path: "clienti", component: UniversalCrudComponent,data:{ ...customers, mockData: mockData } ,title:'Clienti'},
    { path: "localita", component: UniversalCrudComponent,data:{ ...locations, mockData: mockData } ,title:'Località'},
    { path: "pacchetti", component: UniversalCrudComponent,data:{ ...bundles, mockData: mockData } ,title:'Pacchetti'},
    { path: "tariffario", component: UniversalCrudComponent,data:{ ...rates, mockData: mockData } ,title:'Tariffario'},
    { path: "stagioni", component: AvailabilityComponent ,title:'Stagioni'},
    { path: "disponibilita", component: AvailabilityComponent ,title:'Disponibilita'},
    ],
  },
  { path: "login", component: LoginComponent },
  { path: "registrazione", component: RegistrationComponent },
  { path: "recupero-password", component: RecoveryPasswordComponent },
  { path: "cambia-password", component: ChangePasswordComponent },
  { path: "registration", component: RegistrationComponent },
  { path: "recovery-password", component: RecoveryPasswordComponent },
  { path: "change-password", component: ChangePasswordComponent },
  { path: ":id", component: undefined },
  { path: ":id/:id", component: undefined },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
